import React, {isValidElement, useState} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';

import {
  ActionButtonBuilderType,
  ActionMenuItemType,
  defaultButtonBuilder,
  SpacingDummyActionButton,
} from './ActionsButton';

interface Props {
  action: ActionMenuItemType;
  children?: React.ReactElement | ActionButtonBuilderType;
}

/* generic component to show a button which opens a dropdown menu with several avilable actions */
export const SingleActionButton = ({
  action,
  children = defaultButtonBuilder,
}: Props): JSX.Element => {
  const [isPending, setPending] = useState(false);

  // I swear I tried to cancel the promise on unmount but it didn't work
  // so we track the mounted status and avoid updating state after it's unmounted
  const isMounted = React.useRef(true);

  React.useEffect(
    () => () => {
      isMounted.current = false;
    },
    []
  );

  const getIcon = (icon: string) =>
    `fa-fw ${isPending ? 'fas fa-circle-notch fa-spin' : icon}`;

  function captureCallbackPromise() {
    setPending(true);

    function restorePending<V>(e: V): V {
      if (isMounted.current) {
        setPending(false);
      }
      return e;
    }

    return Promise.resolve(action.callback()).then(
      restorePending,
      restorePending
    );
  }

  const button = isValidElement(children)
    ? children
    : children({
        className: 'btn btn-link py-0 px-1',
        disabled: isPending || action.disabled === true,
        children: <i className={getIcon(action.icon)} />,
      });

  return (
    <LazyTooltip placement="left" tooltip={action.text}>
      <div onClick={action.disabled ? undefined : captureCallbackPromise}>
        {button}
      </div>
    </LazyTooltip>
  );
};

export {SpacingDummyActionButton};
